/* EDGE Custom Print designer.
   Customer uploads a photo, adds text and shapes, sees it on a real photo of The EDGE, and adds it to the cart.
   Needs fabric.js 5 (and heic2any for iPhone photos) loaded first, plus config.js.
   Plan: projects/website/plans/2026-10-01-custom-print-app.md
   All customer-facing words in this file are DRAFTS until Andrew approves them (plan step 2.5). */
(function () {
  "use strict";
  const CFG = Object.assign({}, window.EDGE_CP_DEFAULTS, window.EDGE_CP_CONFIG || {});
  const root = document.getElementById("edge-cp");
  if (!root || !window.fabric) return;
  const onShopify = !!(window.Shopify && window.Shopify.shop);
  const EDIT = 600; // editor canvas size in its own pixels
  const money = (n) => "$" + n.toFixed(2);

  // ---------- state ----------
  const S = {
    mode: "single", // single | pack
    size: "6",
    qty: 1,
    packUnits: 3,
    packStyle: "same", // same | each
    unit: 0,
    unitStates: [null], // canvas JSON per pack unit (for "each")
    files: {}, // fileId -> File (originals to send to review)
    rights: false,
    lowResAccepted: false,
    history: [],
    future: [],
    restoring: false,
  };

  // ---------- markup (DRAFT words) ----------
  const ICON = {
    photo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 16-5-5-8 9"/></svg>',
    text: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 6V4h14v2M12 4v16M9 20h6"/></svg>',
    undo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/></svg>',
    redo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m15 14 5-5-5-5"/><path d="M20 9H10a6 6 0 0 0 0 12h3"/></svg>',
  };
  const SHAPES = [
    ["circle", '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" fill="currentColor"/></svg>', "Circle"],
    ["square", '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" fill="currentColor"/></svg>', "Square"],
    ["rounded", '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5" fill="currentColor"/></svg>', "Rounded"],
    ["triangle", '<svg viewBox="0 0 24 24"><path d="M12 3 22 21H2z" fill="currentColor"/></svg>', "Triangle"],
    ["star", '<svg viewBox="0 0 24 24"><path d="m12 2 3 7 7 .6-5.4 4.7 1.7 7.2L12 17.8 5.7 21.5l1.7-7.2L2 9.6 9 9z" fill="currentColor"/></svg>', "Star"],
    ["heart", '<svg viewBox="0 0 24 24"><path d="M12 21s-8-5.2-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 5.8-8 11-8 11z" fill="currentColor"/></svg>', "Heart"],
  ];

  // Textures for shapes and text, drawn in-house from the chosen colour (no outside images, no rights issues).
  const TEXTURES = [
    ["carbon", "Carbon fiber"], ["brushed", "Brushed metal"], ["wood", "Wood grain"], ["camo", "Camo"],
    ["snow", "Snow"], ["diamond", "Diamond plate"], ["stripes", "Stripes"], ["dots", "Dots"],
  ];

  root.classList.add("cp");
  root.innerHTML = `
  <h2>Make it yours</h2>
  <p class="cp-sub">Your photo, printed on The EDGE. You see exactly where it goes before you order.</p>

  <div class="cp-guide" data-el="guide" role="region" aria-label="Step-by-step help" aria-live="polite">
    <div class="cp-g-top">
      <span class="cp-g-count" data-el="gcount">Step 1 of 6</span>
      <span class="cp-g-dots" data-el="gdots"></span>
      <button class="cp-g-x" data-act="ghide" aria-label="Hide the steps">Hide steps</button>
    </div>
    <b class="cp-g-title" data-el="gtitle"></b>
    <p class="cp-g-text" data-el="gtext"></p>
    <div class="cp-g-btns">
      <button class="cp-mini" data-act="gback">Back</button>
      <button class="cp-mini cp-g-next" data-act="gnext">Next</button>
    </div>
  </div>
  <button class="cp-mini cp-g-show" data-act="gshow" hidden>Show the steps</button>

  <div class="cp-card cp-o-choose" style="margin-bottom:16px">
    <h3>1. Choose</h3>
    <div class="cp-pills" data-group="mode">
      <button class="cp-pill" data-mode="single" aria-pressed="true"><b>One EDGE</b><span>From ${money(CFG.prices.single["6"])}</span></button>
      <button class="cp-pill" data-mode="pack" data-units="3" aria-pressed="false"><b>3-pack</b><span>${money(CFG.prices.pack[3])}</span></button>
      <button class="cp-pill" data-mode="pack" data-units="5" aria-pressed="false"><b>5-pack</b><span>${money(CFG.prices.pack[5])}</span></button>
      <button class="cp-pill" data-mode="pack" data-units="10" aria-pressed="false"><b>10-pack</b><span>${money(CFG.prices.pack[10])}</span></button>
    </div>
    <div class="cp-pills" data-group="size" style="margin-top:12px">
      <button class="cp-pill" data-size="6" aria-pressed="true"><b>${printName("6")}</b><span>6 × 6 in · ${money(CFG.prices.single["6"])}</span></button>
      <button class="cp-pill" data-size="8" aria-pressed="false"><b>${printName("8")}</b><span>8 × 8 in · ${money(CFG.prices.single["8"])}</span></button>
    </div>
    <p class="cp-hint" data-el="sizehint">Print size is the size of your art on top. Every EDGE is the same 18 × 14 in.</p>
    <div class="cp-pills" data-group="packstyle" style="margin-top:12px" hidden>
      <button class="cp-pill" data-style="same" aria-pressed="true"><b>Same design on every EDGE</b><span>Included</span></button>
      <button class="cp-pill" data-style="each" aria-pressed="false"><b>A different design on each</b><span>+${money(CFG.addons.extraDesign.price)} per extra design</span></button>
    </div>
  </div>

  <div class="cp-grid">
    <div class="cp-col">
      <div class="cp-card cp-o-design">
        <h3>2. Design <span data-el="unitlabel"></span></h3>
        <div class="cp-units" data-el="units" hidden style="margin-bottom:12px"></div>
        <div class="cp-stage">
          <div class="cp-stage-inner"><canvas data-el="canvas" width="${EDIT}" height="${EDIT}"></canvas></div>
          <div class="cp-empty" data-el="empty"><div><b>Start with a photo</b>JPG, PNG, WebP or iPhone photos, up to 25 MB.<br>Bigger photos print sharper.</div></div>
          <div class="cp-stage-label"><span data-el="sizelabel">Your Regular print, 6 × 6 in. The light edge is a 0.2 in safety margin.</span><span>Drag, pinch or use the corners to resize</span></div>
        </div>
        <div class="cp-tools">
          <button class="cp-tool cp-primary" data-act="photo">${ICON.photo}Add photo</button>
          <button class="cp-tool" data-act="text">${ICON.text}Add text</button>
          <button class="cp-tool" data-act="undo" disabled>${ICON.undo}Undo</button>
          <button class="cp-tool" data-act="redo" disabled>${ICON.redo}Redo</button>
        </div>
        <input type="file" data-el="file" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif" hidden>
      </div>

      <div class="cp-card cp-o-shapes">
        <h3>Shapes</h3>
        <div class="cp-shapes">${SHAPES.map(([k, svg, name]) => `<button class="cp-tool" data-shape="${k}" title="${name}" aria-label="${name}">${svg}</button>`).join("")}</div>
      </div>

      <div class="cp-card cp-o-insp" data-el="inspector">
        <h3>Selected item</h3>
        <p class="cp-hint" data-el="nosel" style="margin:0">Tap something in the design to change it.</p>
        <div data-el="selbox" hidden>
          <div class="cp-row" data-el="textrow" hidden style="margin-bottom:10px">
            <select class="cp-select" data-el="font" aria-label="Font">${CFG.fonts.map(([f]) => `<option value="${f}" style="font-family:'${f}'">${f}</option>`).join("")}</select>
            <button class="cp-mini" data-act="outline" aria-pressed="false">White outline</button>
          </div>
          <div class="cp-palette" data-el="palette">${CFG.colors.map(([n, h]) => `<button class="cp-swatch" style="background:${h}" data-color="${h}" title="${n}" aria-label="${n}" aria-pressed="false"></button>`).join("")}</div>
          <div class="cp-tex" data-el="textures">
            <span class="cp-tex-label">Texture</span>
            <div class="cp-tex-row">
              <button class="cp-texbtn" data-texture="" aria-pressed="true"><i class="cp-tex-none"></i><span>None</span></button>
              ${TEXTURES.map(([k, n]) => `<button class="cp-texbtn" data-texture="${k}" aria-pressed="false" title="${n}"><i></i><span>${n}</span></button>`).join("")}
            </div>
          </div>
          <div class="cp-row" style="margin-top:12px">
            <button class="cp-mini" data-act="fill">Fill area</button>
            <button class="cp-mini" data-act="fit">Fit inside</button>
            <button class="cp-mini" data-act="center">Center</button>
            <button class="cp-mini" data-act="forward">Bring forward</button>
            <button class="cp-mini" data-act="back">Send back</button>
            <button class="cp-mini" data-act="dup">Duplicate</button>
            <button class="cp-mini" data-act="del">Delete</button>
          </div>
        </div>
      </div>
    </div>

    <div class="cp-col cp-col-preview">
      <div class="cp-preview cp-o-prev"><canvas data-el="preview"></canvas><span class="cp-preview-note">Preview on a real EDGE. Printed colors can vary slightly.</span></div>

      <div class="cp-card cp-quality cp-o-qual" data-el="quality">
        <h3 style="margin:0">Print quality</h3>
        <div class="cp-meter"><i></i></div>
        <div class="cp-q-text" data-el="qtext">Add a photo to check it.</div>
        <div class="cp-addons" data-el="addons" hidden>
          <label class="cp-check"><input type="checkbox" data-el="lowres"><span>I understand this photo may print a little soft.</span></label>
          <label class="cp-check"><input type="checkbox" data-addon="upscale"><span><b>Upscale +${money(CFG.addons.upscale.price)}</b>: we enlarge your photo with care before printing.</span></label>
          <label class="cp-check"><input type="checkbox" data-addon="touchup"><span><b>Touch-up +${money(CFG.addons.touchup.price)}</b>: we clean up color, light and small flaws, ready within 1 business day.</span></label>
        </div>
      </div>

      <div class="cp-summary cp-o-sum">
        <label class="cp-check"><input type="checkbox" data-el="rights"><span>This image is mine, or I have the right to use it (my own photo, art I made, or public domain). Every image is reviewed before printing.</span></label>
        <div class="cp-row" data-el="qtyrow"><span style="font-weight:600">Quantity</span><span class="cp-qty"><button data-act="minus" aria-label="Fewer">−</button><output data-el="qty">1</output><button data-act="plus" aria-label="More">+</button></span></div>
        <div class="cp-lines" data-el="lines"></div>
        <button class="cp-buy" data-act="buy" disabled>Add to cart</button>
        <div class="cp-why" data-el="why"></div>
      </div>
    </div>
  </div>
  <div class="cp-busy" data-el="busy"><div><span class="cp-spin"></span><span data-el="busytext">Saving your design…</span></div></div>`;

  const $ = (sel) => root.querySelector(sel);
  const el = (name) => root.querySelector(`[data-el="${name}"]`);

  // ---------- editor canvas ----------
  const canvas = new fabric.Canvas(el("canvas"), {
    preserveObjectStacking: true,
    backgroundColor: "#2d2d2b",
    selectionColor: "rgba(254,193,17,.15)",
    selectionBorderColor: "#FEC111",
  });
  canvas.setDimensions({ width: "100%", height: "100%" }, { cssOnly: true });
  fabric.Object.prototype.set({
    transparentCorners: false, cornerColor: "#FEC111", cornerStrokeColor: "#333", borderColor: "#FEC111",
    cornerStyle: "circle", cornerSize: 16, touchCornerSize: 34, padding: 4,
  });
  // The dark square is the print area. Its outer 0.2 in is a lighter band: art there is cut off,
  // so nothing gets trimmed when the transfer is cut. Drawn on screen only, never in the print file.
  canvas.on("after:render", (e) => {
    if (e && e.ctx && e.ctx !== canvas.getContext()) return; // print and preview exports skip it
    const ctx = canvas.getContext();
    const k = canvas.lowerCanvasEl.width / EDIT;
    const { m } = safeArea();
    const W = canvas.lowerCanvasEl.width, M = m * k;
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = "rgba(255,255,255,0.13)";
    ctx.beginPath();
    ctx.rect(0, 0, W, W);
    ctx.rect(M, M, W - 2 * M, W - 2 * M);
    ctx.fill("evenodd");
    ctx.restore();
  });

  // print size names (Andrew, 2026-10-04: Regular / XL, always shown as the print, not the EDGE)
  function printName(size) { return size === "8" ? "XL print" : "Regular print"; }
  function printLabel(size) { return `${printName(size)} (${size} × ${size} in)`; }
  function currentSize() {
    return S.mode === "pack" ? CFG.packPrintSize : S.size;
  }

  // ---------- adding things ----------
  let uid = 0;
  const newId = (p) => `${p}${Date.now().toString(36)}${(uid++).toString(36)}`;

  async function addPhoto(file) {
    if (!file) return;
    if (file.size > 25 * 1024 * 1024) return toast("That file is over 25 MB. Try a smaller copy.");
    let blob = file;
    const isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
    if (isHeic) {
      if (!window.heic2any) return toast("iPhone photo support didn't load. Try a JPG.");
      busy(true, "Opening your iPhone photo…");
      try { blob = await window.heic2any({ blob: file, toType: "image/jpeg", quality: 0.95 }); }
      catch { busy(false); return toast("That iPhone photo couldn't be opened. Try exporting it as a JPG."); }
      busy(false);
    } else if (!/^image\/(jpeg|png|webp)$/.test(file.type)) {
      return toast("Please use a JPG, PNG, WebP or iPhone photo.");
    }
    const fileId = newId("f");
    S.files[fileId] = { file, type: isHeic ? "image/heic" : file.type };
    const url = URL.createObjectURL(blob);
    fabric.Image.fromURL(url, (img) => {
      if (!img || !img.width) return toast("That image couldn't be read.");
      img.set({ edgeFile: fileId, edgeKind: "photo" });
      coverCanvas(img);
      canvas.add(img);
      canvas.sendToBack(img);
      canvas.setActiveObject(img);
      changed();
    });
  }

  // Safe area: the print square minus the buffer on every side. Art outside it is cut off on screen
  // and in the print file, so nothing gets trimmed when the transfer is cut (0.2 in, Andrew 2026-10-02).
  function safeArea() {
    const m = (EDIT / Number(currentSize())) * (CFG.bufferInches || 0);
    return { m, s: EDIT - 2 * m };
  }
  function applySafeArea() {
    const { m, s } = safeArea();
    canvas.clipPath = new fabric.Rect({ left: m, top: m, width: s, height: s, absolutePositioned: true });
  }
  // Fill area: cover the whole safe area (photos and shapes); text is sized to its full width.
  // Size at scale 1, outline included, so the item's visible edge lands exactly on the safe area.
  const baseSize = (obj) => [obj.getScaledWidth() / obj.scaleX, obj.getScaledHeight() / obj.scaleY];
  function coverCanvas(obj) {
    const { s: area } = safeArea();
    const [w, h] = baseSize(obj);
    const k = obj.edgeKind === "text" ? Math.min(area / w, area / h) : Math.max(area / w, area / h);
    obj.set({ scaleX: k, scaleY: k, angle: 0 });
    obj.setPositionByOrigin(new fabric.Point(EDIT / 2, EDIT / 2), "center", "center");
    obj.setCoords();
  }
  // Fit inside: the whole item shows, as big as the safe area allows.
  function fitCanvas(obj) {
    const { s: area } = safeArea();
    const [w, h] = baseSize(obj);
    const k = Math.min(area / w, area / h);
    obj.set({ scaleX: k, scaleY: k, angle: 0 });
    obj.setPositionByOrigin(new fabric.Point(EDIT / 2, EDIT / 2), "center", "center");
    obj.setCoords();
  }

  function addText() {
    const t = new fabric.Textbox("Your text", {
      fontFamily: CFG.fonts[0][0], fontWeight: CFG.fonts[0][1], fontSize: 64, fill: "#FFFFFF",
      textAlign: "center", width: EDIT * 0.7, edgeKind: "text", edgeColor: "#FFFFFF", paintFirst: "stroke", strokeWidth: 0, stroke: "#FFFFFF",
    });
    t.setPositionByOrigin(new fabric.Point(EDIT / 2, EDIT / 2), "center", "center");
    canvas.add(t);
    canvas.setActiveObject(t);
    t.enterEditing();
    t.selectAll();
    changed();
  }

  function addShape(kind) {
    const fill = "#FEC111";
    let o;
    const c = { left: EDIT / 2, top: EDIT / 2, originX: "center", originY: "center", fill, edgeKind: "shape", edgeColor: fill, strokeWidth: 0 };
    if (kind === "circle") o = new fabric.Circle({ ...c, radius: 80 });
    if (kind === "square") o = new fabric.Rect({ ...c, width: 160, height: 160 });
    if (kind === "rounded") o = new fabric.Rect({ ...c, width: 160, height: 160, rx: 28, ry: 28 });
    if (kind === "triangle") o = new fabric.Triangle({ ...c, width: 170, height: 150 });
    if (kind === "star") {
      const pts = [];
      for (let i = 0; i < 10; i++) {
        const r = i % 2 ? 40 : 90, a = (Math.PI / 5) * i - Math.PI / 2;
        pts.push({ x: r * Math.cos(a), y: r * Math.sin(a) });
      }
      o = new fabric.Polygon(pts, c);
    }
    if (kind === "heart") o = new fabric.Path("M 80 150 C 80 150 0 100 0 45 C 0 15 25 0 45 0 C 60 0 75 10 80 25 C 85 10 100 0 115 0 C 135 0 160 15 160 45 C 160 100 80 150 80 150 Z", c);
    canvas.add(o);
    canvas.setActiveObject(o);
    changed();
  }

  // ---------- inspector ----------
  function syncInspector() {
    const o = canvas.getActiveObject();
    el("nosel").hidden = !!o;
    el("selbox").hidden = !o;
    if (!o) return;
    const isText = o.edgeKind === "text";
    const isPhoto = o.edgeKind === "photo";
    el("textrow").hidden = !isText;
    el("palette").hidden = isPhoto;
    el("textures").hidden = isPhoto;
    if (!isPhoto) {
      const col = o.edgeColor || (typeof o.fill === "string" ? o.fill : "#FEC111");
      root.querySelectorAll(".cp-texbtn").forEach((b) => {
        b.setAttribute("aria-pressed", String((b.dataset.texture || null) === (o.edgeTexture || null)));
        if (b.dataset.texture) b.querySelector("i").style.backgroundImage = `url(${textureThumb(b.dataset.texture, col)})`;
      });
    }
    if (isText) {
      el("font").value = o.fontFamily;
      $('[data-act="outline"]').setAttribute("aria-pressed", o.strokeWidth > 0 ? "true" : "false");
    }
    root.querySelectorAll(".cp-swatch").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.color.toUpperCase() === String(o.edgeColor || o.fill).toUpperCase())));
  }

  function setColor(hex) {
    const o = canvas.getActiveObject();
    if (!o || o.edgeKind === "photo") return;
    o.set({ edgeColor: hex, fill: o.edgeTexture ? makePattern(o.edgeTexture, hex) : hex });
    if (o.edgeKind === "text" && CFG.darkColors.includes(hex) && !o.strokeWidth) o.set({ stroke: "#FFFFFF", strokeWidth: 3 });
    canvas.requestRenderAll();
    changed();
    syncInspector();
  }

  function setTexture(name) {
    const o = canvas.getActiveObject();
    if (!o || o.edgeKind === "photo") return;
    const col = o.edgeColor || (typeof o.fill === "string" ? o.fill : "#FEC111");
    o.set({ edgeTexture: name || null, edgeColor: col, fill: name ? makePattern(name, col) : col });
    canvas.requestRenderAll();
    changed();
    syncInspector();
  }

  // ---------- textures ----------
  // Each texture is a seamless 256 px tile built from shades of the chosen colour, shown at 96 editor units
  // (about 1 in on a 6 in print), so it stays sharp in the 300 DPI print file.
  const TILE = 256, TILE_SCALE = 0.375;
  const tiles = {}, thumbs = {};
  function rng(seed) {
    return () => { seed = (seed + 0x6d2b79f5) | 0; let t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }
  function shadeRgb(hex, f) {
    const n = parseInt(hex.slice(1), 16), to = f < 0 ? 0 : 255, p = Math.abs(f);
    return [n >> 16, (n >> 8) & 255, n & 255].map((c) => Math.round(c + (to - c) * p));
  }
  const shade = (hex, f) => `rgb(${shadeRgb(hex, f).join(",")})`;
  // draws again on the far side of the tile near its edges, so the tile repeats without seams
  function wrapped(draw, x, y, r) {
    for (const dx of [-TILE, 0, TILE]) for (const dy of [-TILE, 0, TILE]) {
      if (x + dx > -r && x + dx < TILE + r && y + dy > -r && y + dy < TILE + r) draw(x + dx, y + dy);
    }
  }
  function textureTile(name, hex) {
    const key = name + hex;
    if (tiles[key]) return tiles[key];
    const c = document.createElement("canvas");
    c.width = c.height = TILE;
    const x = c.getContext("2d"), R = rng(7), T = TILE;
    x.fillStyle = hex; x.fillRect(0, 0, T, T);
    if (name === "carbon") {
      const q = T / 8;
      for (let i = 0; i < 8; i++) for (let j = 0; j < 8; j++) {
        const across = (i + j) % 2 === 0;
        const g = across ? x.createLinearGradient(0, j * q, 0, (j + 1) * q) : x.createLinearGradient(i * q, 0, (i + 1) * q, 0);
        g.addColorStop(0, shade(hex, -0.5)); g.addColorStop(0.5, shade(hex, 0.15)); g.addColorStop(1, shade(hex, -0.5));
        x.fillStyle = g; x.fillRect(i * q + 1, j * q + 1, q - 2, q - 2);
      }
    } else if (name === "brushed") {
      for (let y = 0; y < T; y++) { x.fillStyle = shade(hex, (R() - 0.5) * 0.3); x.fillRect(0, y, T, 1); }
      x.globalAlpha = 0.35;
      for (let k = 0; k < 40; k++) { x.fillStyle = shade(hex, R() < 0.5 ? 0.35 : -0.35); x.fillRect(0, Math.floor(R() * T), T, 1); }
      x.globalAlpha = 1;
    } else if (name === "wood") {
      const img = x.getImageData(0, 0, T, T), d = img.data;
      for (let y = 0; y < T; y++) for (let xx = 0; xx < T; xx++) {
        const ring = Math.sin(2 * Math.PI * (y / T * 7 + 0.18 * Math.sin(2 * Math.PI * xx / T * 2) + 0.05 * Math.sin(2 * Math.PI * xx / T * 5)));
        const [r, g, b] = shadeRgb(hex, -0.12 + 0.2 * ring - (ring > 0.85 ? 0.18 : 0));
        const o = (y * T + xx) * 4; d[o] = r; d[o + 1] = g; d[o + 2] = b;
      }
      x.putImageData(img, 0, 0);
    } else if (name === "camo") {
      const tones = [shade(hex, -0.35), shade(hex, 0.3), shade(hex, -0.65)];
      for (let k = 0; k < 45; k++) {
        x.fillStyle = tones[k % 3];
        const cx = R() * T, cy = R() * T;
        for (let b = 0; b < 5; b++) {
          const bx = cx + (R() - 0.5) * 40, by = cy + (R() - 0.5) * 30, r = 10 + R() * 18, rot = R() * Math.PI;
          wrapped((px, py) => { x.beginPath(); x.ellipse(px, py, r * 1.4, r, rot, 0, 2 * Math.PI); x.fill(); }, bx, by, r * 1.5);
        }
      }
    } else if (name === "snow") {
      for (let k = 0; k < 260; k++) {
        const px = R() * T, py = R() * T, r = 0.8 + R() * R() * 3.4;
        x.fillStyle = `rgba(255,255,255,${0.5 + R() * 0.45})`;
        wrapped((ax, ay) => { x.beginPath(); x.arc(ax, ay, r, 0, 2 * Math.PI); x.fill(); }, px, py, r);
      }
    } else if (name === "diamond") {
      x.fillStyle = shade(hex, -0.12); x.fillRect(0, 0, T, T);
      const q = T / 4;
      for (let i = 0; i < 4; i++) for (let j = 0; j < 4; j++) for (const [ox, oy, a] of [[0.3, 0.3, 1], [0.75, 0.75, -1]]) {
        x.save(); x.translate((i + ox) * q, (j + oy) * q); x.rotate(a * Math.PI / 4);
        x.fillStyle = shade(hex, -0.45); x.fillRect(-q * 0.32 + 1.5, -q * 0.09 + 1.5, q * 0.64, q * 0.18);
        x.fillStyle = shade(hex, 0.35); x.fillRect(-q * 0.32, -q * 0.09, q * 0.64, q * 0.18);
        x.restore();
      }
    } else if (name === "stripes") {
      x.strokeStyle = shade(hex, -0.35); x.lineWidth = 12;
      for (let i = -T; i <= 2 * T; i += 32) { x.beginPath(); x.moveTo(i, 0); x.lineTo(i + T, T); x.stroke(); }
    } else if (name === "dots") {
      x.fillStyle = shade(hex, -0.4);
      for (let j = 0; j < T / 16; j++) for (let i = 0; i < T / 16; i++) {
        const px = i * 16 + (j % 2 ? 8 : 0) + 4, py = j * 16 + 8;
        wrapped((ax, ay) => { x.beginPath(); x.arc(ax, ay, 4, 0, 2 * Math.PI); x.fill(); }, px, py, 4);
      }
    }
    tiles[key] = c;
    return c;
  }
  function makePattern(name, hex) {
    return new fabric.Pattern({ source: textureTile(name, hex), repeat: "repeat", patternTransform: [TILE_SCALE, 0, 0, TILE_SCALE, 0, 0] });
  }
  function textureThumb(name, hex) {
    const key = name + hex;
    if (!thumbs[key]) {
      const t = document.createElement("canvas"); t.width = t.height = 64;
      t.getContext("2d").drawImage(textureTile(name, hex), 0, 0, 128, 128, 0, 0, 64, 64);
      thumbs[key] = t.toDataURL();
    }
    return thumbs[key];
  }

  async function setFont(name) {
    const o = canvas.getActiveObject();
    if (!o || o.edgeKind !== "text") return;
    const weight = (CFG.fonts.find(([f]) => f === name) || [name, "400"])[1];
    try { await document.fonts.load(`${weight} 40px "${name}"`); } catch { /* use fallback */ }
    o.set({ fontFamily: name, fontWeight: weight });
    o.initDimensions();
    canvas.requestRenderAll();
    changed();
  }

  // ---------- undo ----------
  // Snapshots keep each texture's name and colour, not the pattern picture; textures are rebuilt on load.
  const PROPS = ["edgeFile", "edgeKind", "edgeTexture", "edgeColor"];
  const snapshot = () => {
    const j = canvas.toJSON(PROPS);
    j.objects.forEach((o) => { if (o.edgeTexture) o.fill = o.edgeColor; });
    return JSON.stringify(j);
  };
  const loadJSON = canvas.loadFromJSON.bind(canvas);
  canvas.loadFromJSON = (json, cb) => loadJSON(json, cb, (o, obj) => { if (o.edgeTexture && obj) obj.set("fill", makePattern(o.edgeTexture, o.edgeColor)); });
  function changed() {
    if (S.restoring) return;
    S.history.push(snapshot());
    if (S.history.length > 40) S.history.shift();
    S.future = [];
    afterChange();
  }
  function restore(json) {
    S.restoring = true;
    canvas.loadFromJSON(json, () => {
      canvas.backgroundColor = "#2d2d2b";
      canvas.renderAll();
      S.restoring = false;
      afterChange();
    });
  }
  function undo() {
    if (S.history.length < 2) return;
    S.future.push(S.history.pop());
    restore(S.history[S.history.length - 1]);
  }
  function redo() {
    if (!S.future.length) return;
    const j = S.future.pop();
    S.history.push(j);
    restore(j);
  }

  // ---------- quality ----------
  function photoDpi(o) {
    const inches = (o.getScaledWidth() / EDIT) * Number(currentSize());
    return Math.round(o.width / inches);
  }
  function designQuality(objects) {
    const photos = objects.filter((o) => o.edgeKind === "photo");
    if (!photos.length) return objects.length ? { dpi: 300, vector: true } : null;
    return { dpi: Math.min(...photos.map(photoDpi)), vector: false };
  }
  function renderQuality() {
    const q = designQuality(canvas.getObjects());
    const box = el("quality");
    box.classList.remove("cp-q-ok", "cp-q-amber", "cp-q-bad");
    const bar = box.querySelector(".cp-meter i");
    el("addons").hidden = true;
    if (!q) { el("qtext").textContent = "Add a photo to check it."; bar.style.width = "0"; return; }
    bar.style.width = Math.min(100, (q.dpi / 300) * 100) + "%";
    if (q.vector) { box.classList.add("cp-q-ok"); el("qtext").textContent = "Sharp. Text and shapes always print crisp."; return; }
    if (q.dpi >= CFG.printDpi) { box.classList.add("cp-q-ok"); el("qtext").textContent = `Sharp: ${q.dpi} DPI at this size.`; }
    else if (q.dpi >= CFG.minDpi) { box.classList.add("cp-q-amber"); el("qtext").textContent = `May print a little soft: ${q.dpi} DPI. Make the photo smaller, use a bigger file, or add an upscale.`; el("addons").hidden = false; }
    else { box.classList.add("cp-q-bad"); el("qtext").textContent = `Too small to print well: ${q.dpi} DPI. Make the photo smaller in the design or use a bigger file${S.mode === "single" && S.size === "8" ? ", or choose the Regular print (6 × 6 in)" : ""}.`; }
  }

  // ---------- preview on the real unit ----------
  const pv = el("preview");
  const pctx = pv.getContext("2d");
  const unitImg = new Image();
  unitImg.crossOrigin = "anonymous"; // the store serves it from its CDN; needed to read and save the preview
  unitImg.src = CFG.unitImage;
  unitImg.onload = () => { pv.width = 1000; pv.height = Math.round((1000 * unitImg.naturalHeight) / unitImg.naturalWidth); drawPreview(); };

  function homography(src, dst) {
    const A = [], b = [];
    for (let i = 0; i < 4; i++) {
      const [x, y] = src[i], [u, v] = dst[i];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v);
    }
    const h = solve(A, b);
    return (x, y) => { const w = h[6] * x + h[7] * y + 1; return [(h[0] * x + h[1] * y + h[2]) / w, (h[3] * x + h[4] * y + h[5]) / w]; };
  }
  function solve(A, b) {
    const n = b.length, M = A.map((r, i) => [...r, b[i]]);
    for (let c = 0; c < n; c++) {
      let p = c;
      for (let r = c + 1; r < n; r++) if (Math.abs(M[r][c]) > Math.abs(M[p][c])) p = r;
      [M[c], M[p]] = [M[p], M[c]];
      for (let r = 0; r < n; r++) {
        if (r === c) continue;
        const f = M[r][c] / M[c][c];
        for (let k = c; k <= n; k++) M[r][k] -= f * M[c][k];
      }
    }
    return M.map((r, i) => r[n] / r[i]);
  }
  function zoneQuad(size, scale) {
    const [W, D] = CFG.plateInches;
    const plate = homography([[0, 0], [W, 0], [W, D], [0, D]], CFG.plateCorners);
    const s = Number(size), x0 = W / 2 - s / 2, y0 = D / 2 - s / 2;
    return [[x0, y0], [x0 + s, y0], [x0 + s, y0 + s], [x0, y0 + s]].map(([x, y]) => plate(x, y).map((v) => v * scale));
  }
  // Maps the flat design onto the unit's top face, pixel by pixel (inverse perspective + smooth sampling).
  // Replaces a triangle mesh whose seams showed as criss-cross lines on the preview (Andrew, 2026-10-02).
  function drawWarped(ctx, design, quad) {
    const iw = design.width, ih = design.height;
    const src = design.getContext("2d").getImageData(0, 0, iw, ih).data;
    const toFlat = homography(quad, [[0, 0], [1, 0], [1, 1], [0, 1]]);
    const xs = quad.map((p) => p[0]), ys = quad.map((p) => p[1]);
    const x0 = Math.max(0, Math.floor(Math.min(...xs))), x1 = Math.min(ctx.canvas.width, Math.ceil(Math.max(...xs)));
    const y0 = Math.max(0, Math.floor(Math.min(...ys))), y1 = Math.min(ctx.canvas.height, Math.ceil(Math.max(...ys)));
    const w = x1 - x0, h = y1 - y0;
    if (w <= 0 || h <= 0) return;
    const out = ctx.getImageData(x0, y0, w, h), d = out.data;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const [u, v] = toFlat(x0 + x + 0.5, y0 + y + 0.5);
        if (u < 0 || u > 1 || v < 0 || v > 1) continue;
        const sx = Math.min(iw - 1.001, Math.max(0, u * iw - 0.5)), sy = Math.min(ih - 1.001, Math.max(0, v * ih - 0.5));
        const ix = sx | 0, iy = sy | 0, fx = sx - ix, fy = sy - iy;
        const i00 = (iy * iw + ix) * 4, i10 = i00 + 4, i01 = i00 + iw * 4, i11 = i01 + 4;
        const w00 = (1 - fx) * (1 - fy), w10 = fx * (1 - fy), w01 = (1 - fx) * fy, w11 = fx * fy;
        const a00 = src[i00 + 3] * w00, a10 = src[i10 + 3] * w10, a01 = src[i01 + 3] * w01, a11 = src[i11 + 3] * w11;
        const a = a00 + a10 + a01 + a11;
        if (a < 0.5) continue;
        const o = (y * w + x) * 4, k = a / 255;
        for (let c = 0; c < 3; c++) {
          const col = (src[i00 + c] * a00 + src[i10 + c] * a10 + src[i01 + c] * a01 + src[i11 + c] * a11) / a;
          d[o + c] = col * k + d[o + c] * (1 - k);
        }
      }
    }
    ctx.putImageData(out, x0, y0);
  }
  // Renders the design without the dark editor background. fabric's toCanvasElement never draws selection
  // handles, so the selection is kept. Dropping it here ended text editing after every key (Andrew, 2026-10-02).
  // Only a multi-item selection is dropped, because it changes how its items are positioned.
  function designCanvas(multiplier) {
    const bg = canvas.backgroundColor;
    const active = canvas.getActiveObject();
    const multi = active && active.type === "activeSelection";
    if (multi) canvas.discardActiveObject();
    canvas.backgroundColor = null;
    const out = canvas.toCanvasElement(multiplier);
    canvas.backgroundColor = bg;
    if (multi) canvas.setActiveObject(active);
    canvas.requestRenderAll();
    return out;
  }
  function paintPreview(ctx, w, design) {
    const scale = w / CFG.unitImageSize[0];
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.drawImage(unitImg, 0, 0, ctx.canvas.width, ctx.canvas.height);
    if (design) {
      const quad = zoneQuad(currentSize(), scale);
      drawWarped(ctx, design, quad);
    }
  }
  let pvTimer = null;
  function drawPreview() {
    if (!unitImg.complete || !pv.width) return;
    clearTimeout(pvTimer);
    pvTimer = setTimeout(() => {
      const has = canvas.getObjects().length > 0;
      paintPreview(pctx, pv.width, has ? designCanvas(1) : null);
    }, 60);
  }

  // ---------- packs ----------
  function renderUnits() {
    const box = el("units");
    const show = S.mode === "pack" && S.packStyle === "each";
    box.hidden = !show;
    el("unitlabel").textContent = show ? `· EDGE ${S.unit + 1} of ${S.packUnits}` : "";
    if (!show) return;
    box.innerHTML = Array.from({ length: S.packUnits }, (_, i) =>
      `<button class="cp-unit" data-unit="${i}" aria-pressed="${i === S.unit}" title="EDGE ${i + 1}">${i + 1}</button>`).join("");
  }
  function saveUnit() { S.unitStates[S.unit] = snapshot(); }
  function switchUnit(i) {
    if (i === S.unit) return;
    saveUnit();
    S.unit = i;
    S.history = []; S.future = [];
    const json = S.unitStates[i];
    if (json) restore(json);
    else { canvas.clear(); canvas.backgroundColor = "#2d2d2b"; canvas.renderAll(); afterChange(); }
    S.history.push(S.unitStates[i] || snapshot());
    renderUnits();
  }

  // ---------- summary ----------
  function addonState() {
    return { upscale: !!$('[data-addon="upscale"]').checked, touchup: !!$('[data-addon="touchup"]').checked };
  }
  function designCount() {
    if (S.mode !== "pack" || S.packStyle === "same") return 1;
    saveUnit();
    return S.unitStates.slice(0, S.packUnits).filter((j) => j && JSON.parse(j).objects.length).length;
  }
  function priceLines() {
    const lines = [];
    const ad = addonState();
    const amber = !el("addons").hidden;
    if (S.mode === "single") {
      lines.push([`Your EDGE, ${printLabel(S.size)} × ${S.qty}`, CFG.prices.single[S.size] * S.qty]);
    } else {
      lines.push([`${S.packUnits}-pack with your design`, CFG.prices.pack[S.packUnits]]);
      if (S.packStyle === "each") {
        const extra = Math.max(0, designCount() - 1);
        if (extra) lines.push([`${extra} extra design${extra > 1 ? "s" : ""}`, extra * CFG.addons.extraDesign.price]);
      }
    }
    if (amber && ad.upscale) lines.push(["Upscale", CFG.addons.upscale.price]);
    if (amber && ad.touchup) lines.push(["Touch-up", CFG.addons.touchup.price]);
    return lines;
  }
  function problems() {
    const out = [];
    const designs = S.mode === "pack" && S.packStyle === "each" ? designCount() : canvas.getObjects().length ? 1 : 0;
    if (!designs) out.push("Add a photo, text or shape to your design.");
    if (S.mode === "pack" && S.packStyle === "each" && designs && designs < S.packUnits) out.push(`Design all ${S.packUnits} EDGEs (${designs} done), or choose the same design on every one.`);
    const q = designQuality(canvas.getObjects());
    if (q && q.dpi < CFG.minDpi) out.push("Your photo is too small to print well at this size.");
    if (q && q.dpi < CFG.printDpi && q.dpi >= CFG.minDpi && !el("lowres").checked) out.push("Tick the box under print quality to go ahead.");
    if (!el("rights").checked) out.push("Tick the box to confirm you can use this image.");
    return out;
  }
  function renderSummary() {
    const lines = priceLines();
    const total = lines.reduce((s, [, v]) => s + v, 0);
    el("lines").innerHTML = lines.map(([k, v]) => `<div><span>${k}</span><span>${money(v)}</span></div>`).join("") +
      `<div class="cp-total"><span>Total</span><span>${money(total)}</span></div>`;
    el("qtyrow").hidden = S.mode !== "single";
    el("qty").textContent = S.qty;
    const p = problems();
    $('[data-act="buy"]').disabled = p.length > 0;
    el("why").textContent = p[0] || "Every design is checked by our team before it prints.";
  }

  function afterChange() {
    el("empty").hidden = canvas.getObjects().length > 0;
    $('[data-act="undo"]').disabled = S.history.length < 2;
    $('[data-act="redo"]').disabled = !S.future.length;
    el("sizelabel").textContent = `Your ${printName(currentSize())}, ${currentSize()} × ${currentSize()} in. The light edge is a ${CFG.bufferInches} in safety margin.`;
    applySafeArea();
    canvas.requestRenderAll();
    renderQuality();
    renderSummary();
    syncInspector();
    drawPreview();
    if (typeof guideUpdate === "function") guideUpdate();
  }

  // ---------- add to cart ----------
  const blobOf = (cnv, type, q) => new Promise((res) => cnv.toBlob(res, type, q));

  async function uploadDesign(meta) {
    const px = Number(currentSize()) * CFG.printDpi;
    const printCanvas = designCanvas(px / EDIT);
    const printBlob = await blobOf(printCanvas, "image/png");
    const pc = document.createElement("canvas");
    pc.width = 1000; pc.height = pv.height;
    paintPreview(pc.getContext("2d"), 1000, designCanvas(1));
    const previewBlob = await blobOf(pc, "image/jpeg", 0.86);
    const usedFiles = [...new Set(canvas.getObjects().filter((o) => o.edgeFile).map((o) => o.edgeFile))].slice(0, 6);
    const originals = usedFiles.map((id, i) => ({ name: `original-${i + 1}`, blob: S.files[id].file, type: S.files[id].type }));
    const parts = [
      { name: "print", blob: printBlob, type: "image/png" },
      { name: "preview", blob: previewBlob, type: "image/jpeg" },
      ...originals,
    ];
    const q = designQuality(canvas.getObjects());
    const body = {
      ...meta,
      size: currentSize(),
      dpi: q ? q.dpi : 300,
      lowResAccepted: !!el("lowres").checked,
      rightsAccepted: true,
      addons: Object.entries(addonState()).filter(([, v]) => v && !el("addons").hidden).map(([k]) => k),
      texts: canvas.getObjects().filter((o) => o.edgeKind === "text").map((o) => o.text),
      parts: parts.map((p) => ({ name: p.name, type: p.type, bytes: p.blob.size })),
    };
    const r = await fetch(`${CFG.apiBase}/api/designs`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
    const created = await r.json();
    if (!r.ok) throw new Error(created.error || "upload_refused");
    const urls = Object.fromEntries(created.uploads.map((u) => [u.name, u.url]));
    for (const p of parts) {
      const up = await fetch(urls[p.name], { method: "PUT", body: p.blob });
      if (!up.ok) throw new Error(`upload_failed_${p.name}`);
    }
    const f = await fetch(`${CFG.apiBase}/api/designs/${created.id}/finalize`, { method: "POST" });
    const fin = await f.json();
    if (!f.ok) throw new Error(fin.error || "finalize_failed");
    return { id: created.id, previewUrl: fin.previewUrl, addons: body.addons };
  }

  async function buy() {
    if (problems().length) return;
    busy(true, "Saving your design…");
    try {
      const designs = [];
      if (S.mode === "pack" && S.packStyle === "each") {
        saveUnit();
        const keep = S.unit;
        for (let i = 0; i < S.packUnits; i++) {
          busy(true, `Saving design ${i + 1} of ${S.packUnits}…`);
          await new Promise((res) => { S.restoring = true; canvas.loadFromJSON(S.unitStates[i], () => { canvas.renderAll(); S.restoring = false; res(); }); });
          designs.push(await uploadDesign({ mode: "pack", packUnits: S.packUnits, unitIndex: i + 1, copyToAll: false }));
        }
        await new Promise((res) => { S.restoring = true; canvas.loadFromJSON(S.unitStates[keep], () => { canvas.backgroundColor = "#2d2d2b"; canvas.renderAll(); S.restoring = false; res(); }); });
      } else {
        designs.push(await uploadDesign(S.mode === "pack" ? { mode: "pack", packUnits: S.packUnits, unitIndex: 1, copyToAll: true } : { mode: "single" }));
      }
      const items = cartItems(designs);
      if (!onShopify) { busy(false); return devShow(items); }
      const missing = items.find((it) => !it.id);
      if (missing) throw new Error("addon_not_set_up");
      busy(true, "Adding to your cart…");
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
      if (!res.ok) throw new Error("cart_failed");
      window.location.href = "/cart";
    } catch (e) {
      busy(false);
      console.error(e);
      toast("Something went wrong saving your design. Please try again, or email info@edge.store and we'll sort it out.");
    }
  }

  function cartItems(designs) {
    const items = [];
    const first = designs[0];
    const size = currentSize();
    if (S.mode === "single") {
      items.push({ id: CFG.variants.single[size], quantity: S.qty, properties: { "Print size": printLabel(size), Preview: first.previewUrl, _design_id: first.id } });
    } else {
      const props = { "Print size": printLabel(size), Designs: S.packStyle === "same" ? "Same design on every EDGE" : `${designs.length} designs`, Preview: first.previewUrl, _design_id: first.id };
      if (designs.length > 1) props._design_ids = designs.map((d) => d.id).join(",");
      items.push({ id: CFG.variants.pack[S.packUnits], quantity: 1, properties: props });
      if (designs.length > 1) items.push({ id: CFG.addons.extraDesign.variant, quantity: designs.length - 1, properties: { "For": `${S.packUnits}-pack`, _design_id: first.id } });
    }
    for (const d of designs) {
      for (const a of d.addons) items.push({ id: CFG.addons[a].variant, quantity: 1, properties: { "For design": d.id.slice(-6).toUpperCase(), _design_id: d.id } });
    }
    return items;
  }

  function devShow(items) {
    const box = el("busy");
    box.classList.add("on");
    box.firstElementChild.innerHTML = `<b>Test mode: this is what would go to the Shopify cart</b><div class="cp-dev">${JSON.stringify(items, null, 2).replace(/</g, "&lt;")}</div><button class="cp-mini" data-act="closedev">Close</button>`;
    window.EDGE_CP_LAST_CART = items;
  }
  function busy(on, msg) {
    const box = el("busy");
    if (msg) { box.firstElementChild.innerHTML = `<span class="cp-spin"></span><span>${msg}</span>`; }
    box.classList.toggle("on", on);
  }
  function toast(msg) { el("why").textContent = msg; el("why").scrollIntoView({ block: "nearest", behavior: "smooth" }); }

  // ---------- step-by-step guide (DRAFT words) ----------
  // Walks the customer through the page one step at a time and highlights the part to use.
  // Steps move on by themselves when the customer has done them (photo added, photo moved).
  const G = { step: 0, chose: false, placed: false, hidden: false };
  try { G.hidden = localStorage.getItem("edge-cp-guide") === "hidden"; } catch { /* storage blocked */ }
  const qualityState = () => {
    const q = designQuality(canvas.getObjects());
    if (!q) return "none";
    if (q.dpi < CFG.minDpi) return "bad";
    return q.dpi < CFG.printDpi ? "amber" : "ok";
  };
  const STEPS = [
    { title: "Pick your EDGE", target: ".cp-o-choose",
      text: () => "One EDGE or a pack, then your print size. You can change this later.", done: () => G.chose },
    { title: "Add your photo", target: ".cp-o-design", auto: true,
      text: () => (S.mode === "pack" && S.packStyle === "each"
        ? "Tap Add photo for EDGE 1. Use the numbered buttons above the square to design each EDGE."
        : "Tap Add photo and choose one from your phone or computer. No photo? Tap Add text or pick a shape."),
      done: () => canvas.getObjects().length > 0 },
    { title: "Place it", target: ".cp-stage", auto: true,
      text: () => "Drag to move it. Pinch, or drag a yellow corner, to resize. Anything in the light edge gets cut off, so keep the important parts inside it.",
      done: () => G.placed },
    { title: "Add words or shapes", target: ".cp-o-shapes", optional: true,
      text: () => "Optional. Tap Add text or a shape, then tap it in the square to change its font or color.", done: () => false },
    { title: "Check your preview", target: ".cp-o-prev",
      text: () => ({
        ok: "This is your print on a real EDGE. Happy with it? Tap Next.",
        amber: "Your photo may print a little soft. Make it smaller in the square, or tick the box under Print quality. You can add an upscale.",
        bad: "Your photo is too small to print well this big. Make it smaller in the square, or use a bigger photo.",
        none: "Add a photo, text or a shape first. Then check it here.",
      })[qualityState()], done: () => false },
    { title: "Confirm and add to cart", target: ".cp-o-sum",
      text: () => { const p = problems(); return p.length ? p[0] : "All set. Tap Add to cart. We check every design before it prints."; }, done: () => false },
  ];

  function guideGo(i, scroll) {
    G.step = Math.max(0, Math.min(STEPS.length - 1, i));
    renderGuide(scroll);
  }
  function guideNext() {
    if (G.step === 0) G.chose = true;
    if (G.step === 2) G.placed = true;
    let i = G.step + 1;
    while (i < STEPS.length - 1 && STEPS[i].auto && STEPS[i].done()) i++;
    guideGo(i, true);
  }
  function inView(node) {
    const r = node.getBoundingClientRect();
    const bottomBar = window.matchMedia("(max-width: 860px)").matches ? el("guide").offsetHeight : 0;
    return r.top >= 0 && r.bottom <= window.innerHeight - bottomBar;
  }
  function renderGuide(scroll) {
    const box = el("guide");
    box.hidden = G.hidden;
    $('[data-act="gshow"]').hidden = !G.hidden;
    root.querySelectorAll(".cp-hl").forEach((n) => n.classList.remove("cp-hl"));
    root.classList.toggle("cp-guided", !G.hidden);
    if (G.hidden) return;
    const st = STEPS[G.step];
    // the sticky preview column sits below the sticky guide instead of under it
    requestAnimationFrame(() => root.style.setProperty("--cp-guide-h", el("guide").offsetHeight + "px"));
    el("gcount").textContent = `Step ${G.step + 1} of ${STEPS.length}`;
    el("gdots").innerHTML = STEPS.map((x, i) => `<i class="${i < G.step ? "on" : i === G.step ? "now" : ""}"></i>`).join("");
    el("gtitle").textContent = st.title;
    el("gtext").textContent = st.text();
    $('[data-act="gback"]').disabled = G.step === 0;
    const last = G.step === STEPS.length - 1;
    const next = $('[data-act="gnext"]');
    next.hidden = last;
    next.textContent = st.optional ? "Skip" : "Next";
    const target = $(st.target);
    if (target) {
      target.classList.add("cp-hl");
      if (scroll && !inView(target)) target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  // called after every change: move on when the current step is done
  function guideUpdate() {
    const st = STEPS[G.step];
    if (st && st.auto && st.done()) return guideNext();
    renderGuide(false);
  }
  function guideSetHidden(h) {
    G.hidden = h;
    try { localStorage.setItem("edge-cp-guide", h ? "hidden" : "shown"); } catch { /* storage blocked */ }
    renderGuide(!h);
  }

  // ---------- events ----------
  root.addEventListener("click", (e) => {
    const b = e.target.closest("button");
    if (!b || !root.contains(b)) return;
    const o = canvas.getActiveObject();
    if (b.dataset.mode || b.dataset.size || b.dataset.style) G.chose = true;
    if (b.dataset.mode) {
      saveUnit();
      S.mode = b.dataset.mode;
      if (S.mode === "pack") S.packUnits = Number(b.dataset.units);
      root.querySelectorAll('[data-group="mode"] .cp-pill').forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      $('[data-group="size"]').hidden = S.mode === "pack";
      el("sizehint").hidden = S.mode === "pack";
      $('[data-group="packstyle"]').hidden = S.mode !== "pack";
      if (S.unit >= S.packUnits) switchUnit(0);
      renderUnits(); afterChange(); return;
    }
    if (b.dataset.size) {
      S.size = b.dataset.size;
      root.querySelectorAll('[data-group="size"] .cp-pill').forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      afterChange(); return;
    }
    if (b.dataset.style) {
      saveUnit();
      S.packStyle = b.dataset.style;
      root.querySelectorAll('[data-group="packstyle"] .cp-pill').forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      if (S.packStyle === "same" && S.unit !== 0) switchUnit(0);
      renderUnits(); afterChange(); return;
    }
    if (b.dataset.unit) return switchUnit(Number(b.dataset.unit));
    if (b.dataset.shape) return addShape(b.dataset.shape);
    if (b.dataset.color) return setColor(b.dataset.color);
    if ("texture" in b.dataset) return setTexture(b.dataset.texture);
    switch (b.dataset.act) {
      case "photo": el("file").click(); break;
      case "text": addText(); break;
      case "undo": undo(); break;
      case "redo": redo(); break;
      case "fill": if (o) { coverCanvas(o); canvas.requestRenderAll(); changed(); } break;
      case "fit": if (o) { fitCanvas(o); canvas.requestRenderAll(); changed(); } break;
      case "center": if (o) { o.setPositionByOrigin(new fabric.Point(EDIT / 2, EDIT / 2), "center", "center"); o.setCoords(); canvas.requestRenderAll(); changed(); } break;
      case "forward": if (o) { canvas.bringForward(o); changed(); } break;
      case "back": if (o) { canvas.sendBackwards(o); changed(); } break;
      case "dup": if (o) o.clone((c) => { c.set({ left: o.left + 20, top: o.top + 20 }); if (c.edgeTexture) c.set("fill", makePattern(c.edgeTexture, c.edgeColor)); canvas.add(c); canvas.setActiveObject(c); changed(); }, PROPS); break;
      case "del": if (o) { canvas.remove(o); canvas.discardActiveObject(); changed(); } break;
      case "outline": if (o && o.edgeKind === "text") { o.set(o.strokeWidth ? { strokeWidth: 0 } : { stroke: "#FFFFFF", strokeWidth: 3 }); canvas.requestRenderAll(); changed(); } break;
      case "minus": S.qty = Math.max(1, S.qty - 1); renderSummary(); break;
      case "plus": S.qty = Math.min(50, S.qty + 1); renderSummary(); break;
      case "buy": buy(); break;
      case "closedev": el("busy").classList.remove("on"); break;
      case "gnext": guideNext(); break;
      case "gback": guideGo(G.step - 1, true); break;
      case "ghide": guideSetHidden(true); break;
      case "gshow": guideSetHidden(false); break;
    }
  });
  el("file").addEventListener("change", (e) => { addPhoto(e.target.files[0]); e.target.value = ""; });
  el("font").addEventListener("change", (e) => setFont(e.target.value));
  root.addEventListener("change", (e) => { if (e.target.matches('input[type="checkbox"]')) { renderSummary(); renderGuide(false); } });
  canvas.on("selection:created", syncInspector);
  canvas.on("selection:updated", syncInspector);
  canvas.on("selection:cleared", syncInspector);
  canvas.on("object:modified", () => { G.placed = true; changed(); });
  canvas.on("text:changed", () => { drawPreview(); renderSummary(); });
  canvas.on("text:editing:exited", changed);
  canvas.on("object:moving", drawPreview);
  canvas.on("object:scaling", () => { drawPreview(); renderQuality(); });
  canvas.on("object:rotating", drawPreview);
  // drop a photo straight onto the editor
  const stage = $(".cp-stage");
  stage.addEventListener("dragover", (e) => e.preventDefault());
  stage.addEventListener("drop", (e) => { e.preventDefault(); addPhoto(e.dataTransfer.files[0]); });
  document.addEventListener("keydown", (e) => {
    if (!root.contains(document.activeElement) && document.activeElement !== document.body) return;
    const o = canvas.getActiveObject();
    if (o && o.isEditing) return;
    if ((e.key === "Delete" || e.key === "Backspace") && o) { canvas.remove(o); canvas.discardActiveObject(); changed(); e.preventDefault(); }
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "z") { e.shiftKey ? redo() : undo(); e.preventDefault(); }
  });

  // fonts ready before first text
  Promise.all(CFG.fonts.map(([f, w]) => document.fonts.load(`${w} 40px "${f}"`).catch(() => null))).then(() => canvas.requestRenderAll());

  // ?pack=3|5|10 (the pack pages' "Custom Print this pack" link) opens in that pack's mode
  try { const pk = new URLSearchParams(location.search).get("pack"); if (["3", "5", "10"].includes(pk)) root.querySelector(`[data-mode="pack"][data-units="${pk}"]`)?.click(); } catch { /* old browser: stays on One EDGE */ }
  S.history.push(snapshot());
  afterChange();
  window.EDGE_CP = { canvas, state: S, addPhoto, addText, addShape, cartItems, priceLines, problems, designCanvas, safeArea, zoneQuad };
})();
